import { render } from "./moonSetAndRise.vue?vue&type=template&id=4a52c2a6&ts=true"
import script from "./moonSetAndRise.vue?vue&type=script&lang=ts"
export * from "./moonSetAndRise.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__